import Vue from 'vue';

import mktoast from 'mk-toast/vue';

Vue.use(mktoast, {
  position: 'right top',
  duration: 4000,
});

Vue.mixin({
  computed: {
    $toast: {
      get () {
        return this.$mktoast;
      },
    },
  },
});
